import axios from '../helpers/axios'
import qs from 'querystring';
import { logError } from '../services';
import { IResponse, IDropdownResponse, IRecentItem } from '../models';
import { alphaSort } from '../helpers';

export const getRecentItems = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  whenAccessed?: Date;
  howAccessedTypes?: string[];
  recordTypes?: string[];
  userName?: string;
  description?: string;
  changesSearch?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
  ipAddress?: string;
  countryCode?: string;
  regionName?: string;
  city?: string;
  zipCode?: string;
  internetServiceProvider?: string;
  organization?: string;
  isMobile?: boolean;
  isProxy?: boolean;
  isHosting?: boolean;
}): Promise<IResponse<IRecentItem[]>> => {
  try {
    const { data } = await axios.get(`/api/recent-items`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getRecentItems failed');
    return Promise.reject(error);
  }
};

export const getHowAccessedTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get('/api/recent-items/how-accessed-types');
    return alphaSort(data, 'description');
  } catch (error) {
    logError(error, 'getHowAccessedTypes failed');
    return Promise.reject(error);
  }
};

export const getRecordTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get('/api/recent-items/record-types');
    return alphaSort(data, 'description');
  } catch (error) {
    logError(error, 'getRecordTypes failed');
    return Promise.reject(error);
  }
};
